import axios from 'axios'
import store from '../store/index'
import router from '../router/index'

const instance = axios.create({ baseURL: process.env.VUE_APP_URL })
instance.interceptors.response.use((response) => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response
}, (error) => {
  if (error.response.status === 401) {
    store.dispatch('auth/logout')
    router.push('/auth')
  }
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error)
})

export {
  instance
}
